import { defaultValue, makeText, setHtml } from '../lib.js';
import {
  fadeIn,
  fadeInTimeoutMS,
  fadeOut,
  handleFadeInOut,
  isClickOutside,
  isClicked,
  resetClick,
  saveClick,
} from './utils.js';

const faceRecoDefText = defaultValue(
  `Please upload a selfie, or a good portrait picture of everyone in your party so we can find your images!`
);

let hasShownFaceRecoTooltip = false;

export function show(text) {
  if (!isClicked('faceRecoBtnClicked')) {
    const element = makeText('.faceReco-tooltip__text');
    setHtml(faceRecoDefText(text), element);

    fadeIn('.faceReco-tooltip');

    document.addEventListener('click', (event) => {
      const selectors = ['.top-panel', '.menu', '#qrr-overlay', '#qrr-container', '#customPopUp'];
      if (isClickOutside(event, selectors)) {
        fadeOut('.faceReco-tooltip');
        if (!hasShownFaceRecoTooltip && !isClicked('uploadPhotoBtnClicked')) {
          setTimeout(() => handleFadeInOut('.ugc-tooltip'), fadeInTimeoutMS);
          hasShownFaceRecoTooltip = true;
        }
      }
    });

    document.querySelector('.add-selfie__btn').addEventListener('click', off);
  }
}

export function off() {
  saveClick('faceRecoBtnClicked');
  fadeOut('.faceReco-tooltip');
}

export function reset() {
  resetClick('faceRecoBtnClicked');
}
